import { lazy } from '@/service/lazy'

export default [{
  name: 'Pacotes Fornecedor',
  path: 'pacotes-fornecedor',
  id: 'pacotes-fornecedor',
  icon: 'fa fa-archive',
  component: lazy('app/default/gerenciador/pacotesfornecedor/index'),
  meta: { requireAuth: true, rules: ['pacote_fornecedor'], root: true },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/pacotesfornecedor.js